import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  anonymous_activityData: any;
  anonymous_activityLoading: boolean;
  anonymous_activityError: SerializedError | null;
} = {
  anonymous_activityData: {},
  anonymous_activityLoading: false,
  anonymous_activityError: null,
};

export const anonymous_activityFunc = createAsyncThunk(
  'anonymous_activity/anonymous_activityFunc',
  async (values: { activityId: string }) => {
    const data1 = JSON.stringify({
      query: `query Anonymous_activity($activityId: String!) {
      anonymous_activity(activityId: $activityId) {
        _id
        quota
        hoursBeforeReservationExpires  
        fee
        externalLink
        externalMail
        externalPhoneNumber
        createdBy {
          displayName
          displayImageUrl
          _id
          role
        }
        duration
        location {
          _id
          address {
            description
            title
          }
          city
          country
          district
          lat
          long
          parking
        }
        participantCount
        price
        title
         listing {
         companionship
          exteriorOrganizer {
            _id
            contact {
              phoneNumber
              phoneNumber2
            }
            details
            imageUrl
            name
            socialMedia {
              facebook
              instagram
              twitter
              website
              youtube
            }
          }
          category
          images
          title
          rating {
            average
            numberOfReviews
          }
          description
          coverImage
          format
          ageInterval
           reviews {
            count
            data {
              _id
              comment
              createdAt
              createdBy {
                _id
                displayImageUrl
                displayName
              }
              rating
              title
            }
          }
        }
        schedule {
          startDate
          endDate
          days {
            _id
            activity {
              _id
            }
            date
            day
            startTime
            endTime
            createdAt
            updatedAt
          }
        }
        additionalDetails
      }
    }`,
      variables: {
        activityId: values?.activityId ?? null,
      },
    });

    const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data1, '');

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const anonymous_activity = createSlice({
  name: 'anonymous_activity',
  initialState,
  reducers: {
    clearAnonymousActivityData: (state) => {
      state.anonymous_activityData = {};
      state.anonymous_activityError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(anonymous_activityFunc.pending, (state) => {
      state.anonymous_activityLoading = true;
    });
    builder.addCase(anonymous_activityFunc.fulfilled, (state, action) => {
      state.anonymous_activityLoading = false;
      state.anonymous_activityData = action.payload?.data?.anonymous_activity;
      state.anonymous_activityError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(anonymous_activityFunc.rejected, (state, action) => {
      state.anonymous_activityLoading = false;
      state.anonymous_activityError = action.error;
    });
  },
});

export const { clearAnonymousActivityData } = anonymous_activity.actions;
export default anonymous_activity.reducer;
